<template>
  <div>
    <standard-header v-bind:custom-logo-url="customLogoUrl" />

    <login-form
      v-if="showLogin"
      v-bind:login-url="loginUrl"
      v-bind:login-hint="loginHint"
      v-bind:return-url="returnUrl"
      v-bind:benefits-app-base-url="benefitsAppBaseUrl"
      v-bind:is-native-client="isNativeClient"
      v-on:totp-setup-required="handleTotpSetupRequired"
      v-on:forgot-username-requested="handleForgotUsername"
      v-on:forgot-password-requested="handleForgotPassword"
    />

    <totp-setup
      v-if="showTotpSetup"
      v-bind:login-url="loginUrl"
      v-bind:return-url="returnUrl"
      v-bind:setup-info="totpSetupInfo"
    />

    <forgot-username
      v-if="showForgotUsername"
      v-bind:forgot-username-url="forgotUsernameUrl"
      v-bind:branding-subdomain="brandingSubdomain"
      v-bind:benefits-app-base-url="benefitsAppBaseUrl"
    />

    <forgot-password
      v-if="showForgotPassword"
      v-bind:forgot-password-url="forgotPasswordUrl"
      v-bind:branding-subdomain="brandingSubdomain"
      v-bind:forgot-password-info="forgotPasswordInfo"
      v-bind:benefits-app-base-url="benefitsAppBaseUrl"
      v-on:forgot-username-requested="handleForgotUsername"
    />

    <standard-footer v-bind:is-native-client="isNativeClient" />
  </div>
</template>

<script>
import LoginHeader from "./components/LoginHeader.vue";
import LoginForm from "./components/LoginForm.vue";
import TotpSetup from "./components/TotpSetup.vue";
import ForgotUsername from "./components/ForgotUsername.vue";
import ForgotPassword from "./components/ForgotPassword.vue";
import LoginFooter from "./components/LoginFooter.vue";

export default {
  name: 'LoginApp',
  data() {
    return {
      returnUrl: document.querySelector("#ReturnUrl")?.value ?? '',
      loginHint: document.querySelector("#LoginHint")?.value ?? '',
      loginUrl: document.querySelector("#LoginUrl")?.value ?? '',
      forgotUsernameUrl: document.querySelector("#ForgotUsernameUrl")?.value ?? '',
      forgotPasswordUrl: document.querySelector("#ForgotPasswordUrl")?.value ?? '',
      benefitsAppBaseUrl: document.querySelector("#BenefitsAppBaseUrl")?.value ?? '',
      customLogoUrl: document.querySelector("#CustomLogoUrl")?.value ?? '',
      brandingSubdomain: document.querySelector("#BrandingSubdomain")?.value ?? '',
      // Rendered inside the mobile app's login webview rather than a browser. That webview only
      // permits the OIDC redirect chain, so links leading anywhere else are hidden rather than
      // left to fail on tap.
      isNativeClient: document.querySelector("#IsNativeClient")?.value === 'true',
      showLogin: true,
      showTotpSetup: false,
      showForgotUsername: false,
      showForgotPassword: false,
      totpSetupInfo: null,
      forgotPasswordInfo: null,
    };
  },
  components: {
    "standard-header": LoginHeader,
    "login-form": LoginForm,
    "totp-setup": TotpSetup,
    "forgot-username": ForgotUsername,
    "forgot-password": ForgotPassword,
    "standard-footer": LoginFooter,
  },
  methods: {
    handleTotpSetupRequired(e) {
      this.hideAllSections();

      this.totpSetupInfo = e;
      this.showTotpSetup = true;
    },
    handleForgotUsername() {
      this.hideAllSections();
      this.showForgotUsername = true;
    },
    handleForgotPassword(e) {
      this.hideAllSections();

      this.forgotPasswordInfo = e;
      this.showForgotPassword = true;
    },
    hideAllSections() {
      this.showLogin = false;
      this.showTotpSetup = false;
      this.showForgotUsername = false;
      this.showForgotPassword = false;
    }
  },
};
</script>

